// extracted by mini-css-extract-plugin
export default {"priceInput":"price-input--priceInput--a1a676","currencySuffix":"price-input--currencySuffix--a73db8"};